export default __webpack_public_path__ + "static/media/category_s.8351f529.png";